const CLASSROOM_TYPE = {
  CLASSROOM: 'CORE',
  JOURNEYS: 'JOURNEYS',
} as const;

type ClassroomType = (typeof CLASSROOM_TYPE)[keyof typeof CLASSROOM_TYPE];

const isCoreType = (type: string): type is ClassroomType => {
  return type === CLASSROOM_TYPE.CLASSROOM;
};

const isJourneyType = (type: string): type is ClassroomType => {
  return type === CLASSROOM_TYPE.JOURNEYS;
};

export { CLASSROOM_TYPE, isCoreType, isJourneyType };
export type { ClassroomType };
